import React from "react";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// vars
// import { PERIOD_ARRAY } from "../../utils/const";

// components
import SelectApplyBtn from "./SelectApplyBtn";

// style
import "./SelectPeriod.scss";

class SelectPeriod extends React.Component {

	// radioArr = PERIOD_ARRAY;

	constructor(props) {
		super(props);
		this.state = {
			radioBtnState: '',
			periodStart: '',
			periodEnd: '',
			// periodStart: 1930,
			// periodEnd: new Date().getFullYear(),
			isDisabled: '',
			isSearchMethode: '',
		};
	}

	// ____________________________________ onHandlers ____________________________________

	onRadioChangeHandler(e) {
		const id = e.currentTarget.id;
		this.setState({
			radioBtnState: id,
			isDisabled: id,
			isSearchMethode: 'radio',
		});
	}

	onPeriodeChangeHandler(e) {
		const id = e.target.id;
		const value = e.target.value;
		// console.log(id);
		// console.log(value);
		if (id === "periodStartID") {
			this.setState({
				periodStart: value,
				isDisabled: value,
				isSearchMethode: 'vantot',
			});
		} else {
			this.setState({
				periodEnd: value,
				isDisabled: value,
				isSearchMethode: 'vantot',
			});
		}
	}

	onSubmitHandler(e) {
		if (this.state.isSearchMethode === 'radio') {
			// console.log('use search methode: radio');
			this.props.onClick(this.state.radioBtnState);
		} else {
			// console.log('use search methode: other');
			this.props.onPeriodBetweenClick(e, this.state.periodStart, this.state.periodEnd);
		}
	}

	// ____________________________________ render ____________________________________

	render() {
		let maxYear = new Date().getFullYear();
		let minYear = 1920;

		return (
			<div className="container-select select-period">
				<div className="row">
					<div className="col-12 col-md-6">

						{/*
						<h3>{(this.state.radioBtnState === '') ? "Choose period" : this.state.radioBtnState}</h3>
						*/}

						<div className="select-intro">
							<p>{i18n.t('select.period.intro')}</p>
							<p className="caption">{i18n.t('select.period.caption')}</p>
						</div>
					</div>


					<div className="col-12 col-md-6">
						<p className='dim'>{i18n.t('select.period.choose', { minyear: minYear, maxyear: maxYear })}</p>

						<form className="form-inline">
							<label className="mb-2 mr-sm-2" htmlFor="periodStartID">{i18n.t('select.period.from')}</label>
							{/* <input type="number" min={minYear} max={maxYear} value="" className="form-control mb-2 mr-sm-2 input-short" placeholder="yyyy" id="periodStartID" onChange={(e) => this.onPeriodeChangeHandler(e)} /> */}
							<input type="number" min={minYear} max={maxYear} value={this.state.periodStart} className="form-control mb-2 mr-sm-2 input-short" placeholder={minYear} id="periodStartID" onChange={(e) => this.onPeriodeChangeHandler(e)} />

							<label className="mb-2 mr-sm-2" htmlFor="periodEndID">{i18n.t('select.period.to')}</label>
							{/* <input type="number" min={minYear} max={maxYear} value="" className="form-control mb-2 mr-sm-2 input-short" placeholder="yyyy" id="periodEndID" onChange={(e) => this.onPeriodeChangeHandler(e)} /> */}
							<input type="number" min={minYear} max={maxYear} value={this.state.periodEnd} className="form-control mb-2 mr-sm-2 input-short" placeholder={maxYear} id="periodEndID" onChange={(e) => this.onPeriodeChangeHandler(e)} />
						</form>

					</div>

				</div>

				<span className="horizontal-line"></span>

				<div className="row">

					<div className="col-12">
						<p className="small">{i18n.t('select.period.trend')}</p>
					</div>

					{
						this.props.periodArray.map((value, key) =>
							<div className="col-12 col-sm-6 col-md-4" key={key}>
								<div className="custom-control custom-radio custom-control-inline">
									<input
										type="radio"
										id={value}
										name="customLocationRadio"
										onChange={(e) => this.onRadioChangeHandler(e)}
										className="custom-control-input"
									/>
									<label className="custom-control-label" htmlFor={value}>{value}</label>
								</div>
							</div>
						)
					}

				</div>


				<SelectApplyBtn
					isdisabled={this.state.isDisabled === ''}
					onClick={(e) => this.onSubmitHandler()}
					// onApplyClick={(e) => this.props.onApplyClick(e, `${this.props.selectedState}`, `${this.state.radioBtnState}`)}
					onApplyClick={(e) => this.props.onApplyClick(e, `${this.props.selectedState}`, (this.state.isSearchMethode === 'radio') ? `${this.state.radioBtnState}` : `${this.state.periodStart} - ${this.state.periodEnd}`)}
				/>

			</div>
		);
	}
}

export default withTranslation()(SelectPeriod);
